// import React, { useEffect, useState } from 'react';
// import axios from 'axios';

// function ProfileForm() {
//   const [districts, setDistricts] = useState([]);
//   const [designations, setDesignations] = useState([]);
//   const [selectedDistrict, setSelectedDistrict] = useState('');
//   const [selectedDesignation, setSelectedDesignation] = useState('');
//   const [profile, setProfile] = useState(null);
//   const [editing, setEditing] = useState(false);
//   const [editedData, setEditedData] = useState({});

//   useEffect(() => {
//     axios.get('https://lcoiapi.emedha.in/api/profile/districts').then(res => setDistricts(res.data));
//   }, []);

//   const handleDistrictChange = (e) => {
//     const district = e.target.value;
//     setSelectedDistrict(district);
//     // axios.get(`https://lcoiapi.emedha.in/api/profile/designations?district=${district}`).then(res => setDesignations(res.data));
// axios.get(`https://lcoiapi.emedha.in/api/profile/designations/${district}`)
//   .then(res => setDesignations(res.data));

// };

//   const handleDesignationChange = (e) => {
//     const des = e.target.value;
//     setSelectedDesignation(des);
//     axios.get(`https://lcoiapi.emedha.in/api/profile?district=${selectedDistrict}&desegnation=${des}`).then(res => setProfile(res.data));
//   };

//   const handleEdit = () => {
//     setEditing(true);
//     setEditedData(profile);
//   };

//   return (
//     <div>
//       <select onChange={handleDistrictChange}>
//         <option value="">Select District</option>
//         {districts.map(d => <option key={d.district} value={d.district}>{d.district}</option>)}
//       </select>

//       {selectedDistrict && (
//         <select onChange={handleDesignationChange}>
//           <option value="">Select Designation</option>
//           {designations.map(d => <option key={d.desegnation} value={d.desegnation}>{d.desegnation}</option>)}
//         </select>
//       )}

//       {profile && !editing && (
//         <div>
//           <h3>{profile.name}</h3>
//           <p>Email: {profile.email}</p>
//           <p>Phone: {profile.number}</p>
//           <button onClick={handleEdit}>Edit</button>
//         </div>
//       )}

//       {editing && (
//         <form>
//           <input value={editedData.name} onChange={e => setEditedData({...editedData, name: e.target.value})} />
//           {/* more fields here */}
//           <button type="submit">Submit</button>
//         </form>
//       )}
//     </div>
//   );
// }

// export default ProfileForm;


// import React, { useEffect, useState } from 'react';
// import axios from 'axios';

// function ProfileForm() {
//   const [districts, setDistricts] = useState([]);
//   const [designations, setDesignations] = useState([]);
//   const [selectedDistrict, setSelectedDistrict] = useState('');
//   const [selectedDesignation, setSelectedDesignation] = useState('');
//   const [profiles, setProfiles] = useState([]);
//   const [editing, setEditing] = useState(false);
//   const [editedData, setEditedData] = useState({});

//   useEffect(() => {
//     axios.get('https://lcoiapi.emedha.in/api/profile/districts')
//       .then(res => setDistricts(res.data));
//   }, []);

//   const handleDistrictChange = (e) => {
//     const district = e.target.value;
//     setSelectedDistrict(district);

//     axios.get(`https://lcoiapi.emedha.in/api/profile/designations/${district}`)
//       .then(res => setDesignations(res.data));
//   };

//   const handleDesignationChange = (e) => {
//     const des = e.target.value;
//     setSelectedDesignation(des);

//     axios.get(`https://lcoiapi.emedha.in/api/profile/${selectedDistrict}/${des}`)
//       .then(res => setProfiles(res.data));
//   };

//   const handleEdit = (profile) => {
//     setEditing(true);
//     setEditedData(profile);
//   };

//   return (
//     <div className="p-6 max-w-4xl mx-auto">
//       <div className="mb-4 flex gap-4">
//         <select
//           className="border rounded-lg px-3 py-2 shadow"
//           onChange={handleDistrictChange}
//           value={selectedDistrict}
//         >
//           <option value="">Select District</option>
//           {districts.map(d => (
//             <option key={d.district} value={d.district}>
//               {d.district}
//             </option>
//           ))}
//         </select>

//         {selectedDistrict && (
//           <select
//             className="border rounded-lg px-3 py-2 shadow"
//             onChange={handleDesignationChange}
//             value={selectedDesignation}
//           >
//             <option value="">Select Designation</option>
//             {designations.map(d => (
//               <option key={d.desegnation} value={d.desegnation}>
//                 {d.desegnation}
//               </option>
//             ))}
//           </select>
//         )}
//       </div>

//       {/* Profiles List */}
//       {profiles.length > 0 && !editing && (
//         <div className="grid md:grid-cols-2 gap-6">
//           {profiles.map(p => (
//             <div key={p.id} className="bg-white rounded-2xl shadow p-4">
//               <img
//                 src={p.image}
//                 alt={p.name}
//                 className="w-24 h-24 object-cover rounded-full mx-auto"
//               />
//               <h3 className="text-xl font-semibold text-center mt-2">{p.name}</h3>
//               <p className="text-gray-600 text-center">{p.desegnation}</p>
//               <p className="text-sm text-gray-500 text-center">📧 {p.email}</p>
//               <p className="text-sm text-gray-500 text-center">📞 {p.number}</p>
//               <button
//                 onClick={() => handleEdit(p)}
//                 className="mt-3 block mx-auto bg-blue-600 text-white px-4 py-2 rounded-xl hover:bg-blue-700"
//               >
//                 Edit
//               </button>
//             </div>
//           ))}
//         </div>
//       )}

//       {/* Edit Form */}
//       {editing && (
//         <form className="bg-white rounded-2xl shadow p-6 mt-6">
//           <input
//             className="w-full border px-3 py-2 mb-4 rounded-lg"
//             value={editedData.name}
//             onChange={e => setEditedData({ ...editedData, name: e.target.value })}
//           />
//           <input
//             className="w-full border px-3 py-2 mb-4 rounded-lg"
//             value={editedData.email}
//             onChange={e => setEditedData({ ...editedData, email: e.target.value })}
//           />
//           <input
//             className="w-full border px-3 py-2 mb-4 rounded-lg"
//             value={editedData.number}
//             onChange={e => setEditedData({ ...editedData, number: e.target.value })}
//           />
//           <button
//             type="submit"
//             className="bg-green-600 text-white px-4 py-2 rounded-xl hover:bg-green-700"
//           >
//             Save
//           </button>
//         </form>
//       )}
//     </div>
//   );
// }

// export default ProfileForm;



// import React, { useEffect, useState } from 'react';
// import axios from 'axios';
// import Modal from 'react-modal';

// Modal.setAppElement('#root'); // important for accessibility

// function ProfileForm() {
//   const [districts, setDistricts] = useState([]);
//   const [designations, setDesignations] = useState([]);
//   const [selectedDistrict, setSelectedDistrict] = useState('');
//   const [selectedDesignation, setSelectedDesignation] = useState('');
//   const [profiles, setProfiles] = useState([]);
//   const [modalOpen, setModalOpen] = useState(false);
//   const [editedData, setEditedData] = useState({});
//   const [otpSent, setOtpSent] = useState(false);
//   const [otp, setOtp] = useState('');

//   useEffect(() => {
//     axios.get('https://lcoiapi.emedha.in/api/profile/districts')
//       .then(res => setDistricts(res.data));
//   }, []);

//   const handleDistrictChange = (e) => {
//     const district = e.target.value;
//     setSelectedDistrict(district);

//     axios.get(`https://lcoiapi.emedha.in/api/profile/designations/${district}`)
//       .then(res => setDesignations(res.data));
//   };

//   const handleDesignationChange = (e) => {
//     const des = e.target.value;
//     setSelectedDesignation(des);

//     axios.get(`https://lcoiapi.emedha.in/api/profile/${selectedDistrict}/${des}`)
//       .then(res => setProfiles(res.data));
//   };

//   const handleEdit = (profile) => {
//     setEditedData(profile);
//     setModalOpen(true);
//   };

//   const handleSendOtp = async () => {
//     const res = await axios.post("https://lcoiapi.emedha.in/api/profile/send-otp", {
//       email: editedData.email
//     });
//     if (res.data.success) {
//       alert("OTP sent to email!");
//       setOtpSent(true);
//     }
//   };

//   const handleVerifyOtp = async () => {
//     const res = await axios.post("https://lcoiapi.emedha.in/api/profile/verify-otp", {
//       otp,
//       data: editedData
//     });
//     if (res.data.success) {
//       alert("Edit request submitted for admin approval!");
//       setModalOpen(false);
//       setOtp('');
//       setOtpSent(false);
//     } else {
//       alert("Invalid OTP!");
//     }
//   };

//   return (
//     <div className="p-6 max-w-4xl mx-auto">
//       {/* Filters */}
//       <div className="mb-4 flex gap-4">
//         <select
//           className="border rounded-lg px-3 py-2 shadow"
//           onChange={handleDistrictChange}
//           value={selectedDistrict}
//         >
//           <option value="Select District">Select District</option>
//           {districts.map(d => (
//             <option key={d.district} value={d.district}>{d.district}</option>
//           ))}
//         </select>

//         {selectedDistrict && (
//           <select
//             className="border rounded-lg px-3 py-2 shadow"
//             onChange={handleDesignationChange}
//             value={selectedDesignation}
//           >
//             <option value="Select Designation">Select Designation</option>
//             {designations.map(d => (
//               <option key={d.desegnation} value={d.desegnation}>{d.desegnation}</option>
//             ))}
//           </select>
//         )}
//       </div>

//       {/* Profiles */}
//       {profiles.length > 0 && (
//         <div className="grid md:grid-cols-2 gap-6">
//           {profiles.map(p => (
//             <div key={p.id} className="bg-white rounded-2xl shadow p-4">
//               <img src={p.image} alt={p.name} className="w-24 h-24 rounded-full mx-auto" />
//               <h3 className="text-xl font-semibold text-center mt-2">{p.name}</h3>
//               <p className="text-gray-600 text-center">{p.desegnation}</p>
//               <p className="text-sm text-gray-500 text-center">📧 {p.email}</p>
//               <p className="text-sm text-gray-500 text-center">📞 {p.number}</p>
//               <button
//                 onClick={() => handleEdit(p)}
//                 className="mt-3 block mx-auto bg-blue-600 text-white px-4 py-2 rounded-xl hover:bg-blue-700"
//               >
//                 Edit
//               </button>
//             </div>
//           ))}
//         </div>
//       )}

//       {/* Modal */}
//       <Modal isOpen={modalOpen} onRequestClose={() => setModalOpen(false)} className="bg-white p-6 rounded-xl max-w-md mx-auto mt-20 shadow">
//         <h2 className="text-xl font-bold mb-4">Edit Profile</h2>

//         <input
//           className="w-full border px-3 py-2 mb-3 rounded-lg"
//           value={editedData.name || ""}
//           onChange={e => setEditedData({ ...editedData, name: e.target.value })}
//         />
//         <input
//           className="w-full border px-3 py-2 mb-3 rounded-lg"
//           value={editedData.number || ""}
//           onChange={e => setEditedData({ ...editedData, number: e.target.value })}
//         />
//         <input
//           className="w-full border px-3 py-2 mb-3 rounded-lg"
//           value={editedData.image || ""}
//           onChange={e => setEditedData({ ...editedData, image: e.target.value })}
//         />

//         {!otpSent ? (
//           <button
//             onClick={handleSendOtp}
//             className="bg-blue-600 text-white px-4 py-2 rounded-lg w-full"
//           >
//             Send OTP
//           </button>
//         ) : (
//           <>
//             <input
//               className="w-full border px-3 py-2 mb-3 rounded-lg"
//               placeholder="Enter OTP"
//               value={otp}
//               onChange={e => setOtp(e.target.value)}
//             />
//             <button
//               onClick={handleVerifyOtp}
//               className="bg-green-600 text-white px-4 py-2 rounded-lg w-full"
//             >
//               Verify OTP & Submit
//             </button>
//           </>
//         )}
//       </Modal>
//     </div>
//   );
// }

// export default ProfileForm;



// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import Modal from "react-modal";

// Modal.setAppElement("#root"); // important for accessibility

// function ProfileForm() {
//   const [districts, setDistricts] = useState([]);
//   const [designations, setDesignations] = useState([]);
//   const [selectedDistrict, setSelectedDistrict] = useState("");
//   const [selectedDesignation, setSelectedDesignation] = useState("");
//   const [profiles, setProfiles] = useState([]);
//   const [modalOpen, setModalOpen] = useState(false);
//   const [editedData, setEditedData] = useState({});
//   const [otpSent, setOtpSent] = useState(false);
//   const [otp, setOtp] = useState("");

//   // Modal custom styles for centering
//   const customStyles = {
//     content: {
//       top: "50%",
//       left: "50%",
//       right: "auto",
//       bottom: "auto",
//       transform: "translate(-50%, -50%)",
//       borderRadius: "16px",
//       padding: "20px",
//       width: "400px",
//       maxWidth: "90%",
//       boxShadow: "0 8px 24px rgba(0,0,0,0.2)",
//     },
//     overlay: {
//       backgroundColor: "rgba(0,0,0,0.5)",
//       zIndex: 50,
//     },
//   };

//   useEffect(() => {
//     axios
//       .get("https://lcoiapi.emedha.in/api/profile/districts")
//       .then((res) => setDistricts(res.data));
//   }, []);

//   const handleDistrictChange = (e) => {
//     const district = e.target.value;
//     setSelectedDistrict(district);

//     axios
//       .get(`https://lcoiapi.emedha.in/api/profile/designations/${district}`)
//       .then((res) => setDesignations(res.data));
//   };

//   const handleDesignationChange = (e) => {
//     const des = e.target.value;
//     setSelectedDesignation(des);

//     axios
//       .get(`https://lcoiapi.emedha.in/api/profile/${selectedDistrict}/${des}`)
//       .then((res) => setProfiles(res.data));
//   };

//   const handleEdit = (profile) => {
//     setEditedData(profile);
//     setModalOpen(true);
//   };

//   const handleSendOtp = async () => {
//     const res = await axios.post(
//       "https://lcoiapi.emedha.in/api/otp/send-otp",
//       { email: editedData.email }
//     );
//     if (res.data.success) {
//       alert("OTP sent to email!");
//       setOtpSent(true);
//     }
//   };

//   const handleVerifyOtp1 = async () => {
//     const res = await axios.post(
//       "https://lcoiapi.emedha.in/api/otp/verify-otp",
//       { otp, data: editedData }
//     );
//     if (res.data.success) {
//       alert("Edit request submitted for admin approval!");
//       setModalOpen(false);
//       setOtp("");
//       setOtpSent(false);
//     } else {
//       alert("Invalid OTP!");
//     }
//   };

//   const handleVerifyOtp = async () => {
//   try {
//     const formData = new FormData();
//     formData.append("otp", otp);

//     // If user selected a new image file
//     if (editedData.image instanceof File) {
//       formData.append("image", editedData.image);
//     } else {
//       formData.append("image", editedData.image || "");
//     }

//     // Append all other fields
//     formData.append("id", editedData.id || "");
//     formData.append("name", editedData.name || "");
//     formData.append("desegnation", editedData.desegnation || "");
//     formData.append("email", editedData.email || "");
//     formData.append("number", editedData.number || "");
//     formData.append("year", editedData.year || "");
//     formData.append("district", editedData.district || "");
//     formData.append("location", editedData.location || "");
//     formData.append("leadership_team", editedData.leadership_team || "");

//     const res = await axios.post(
//       "https://lcoiapi.emedha.in/api/otp/verify-otp",
//       formData,
//       {
//         headers: { "Content-Type": "multipart/form-data" },
//       }
//     );

//     if (res.data.success) {
//       alert("Edit request submitted for admin approval!");
//       setModalOpen(false);
//       setOtp("");
//       setOtpSent(false);
//     } else {
//       alert(res.data.message || "Invalid OTP!");
//     }
//   } catch (err) {
//     console.error("Error uploading:", err);
//     alert("Something went wrong!");
//   }
// };


// //    const [editedData, setEditedData] = useState({});
//   const [previewImage, setPreviewImage] = useState(null); // ✅ add this state

//   const handleFileChange = (e) => {
//     const file = e.target.files[0];
//     if (file) {
//       setPreviewImage(URL.createObjectURL(file)); // preview only
//       setEditedData({ ...editedData, imageFile: file }); // store file
//     }
//   };

//   return (
//     <div className="p-6 max-w-4xl mx-auto">
//       {/* Filters */}
//       <div className="mb-4 flex gap-4">
//         <select
//           className="border rounded-lg px-3 py-2 shadow"
//           onChange={handleDistrictChange}
//           value={selectedDistrict}
//         >
//           <option value="">Select District</option>
//           {districts.map((d) => (
//             <option key={d.district} value={d.district}>
//               {d.district}
//             </option>
//           ))}
//         </select>

//         {selectedDistrict && (
//           <select
//             className="border rounded-lg px-3 py-2 shadow"
//             onChange={handleDesignationChange}
//             value={selectedDesignation}
//           >
//             <option value="">Select Designation</option>
//             {designations.map((d) => (
//               <option key={d.desegnation} value={d.desegnation}>
//                 {d.desegnation}
//               </option>
//             ))}
//           </select>
//         )}
//       </div>

//       {/* Profiles */}
//       {profiles.length > 0 && (
//         <div className="grid md:grid-cols-2 gap-6">
//           {profiles.map((p) => (
//             <div key={p.id} className="bg-white rounded-2xl shadow p-4">
//               <img
//                 src={p.image}
//                 alt={p.name}
//                 className="w-24 h-24 rounded-full mx-auto"
//               />
//               <h3 className="text-xl font-semibold text-center mt-2">
//                 {p.name}
//               </h3>
//               <p className="text-gray-600 text-center">{p.desegnation}</p>
//               <p className="text-sm text-gray-500 text-center">📧 {p.email}</p>
//               <p className="text-sm text-gray-500 text-center">📞 {p.number}</p>
//               <button
//                 onClick={() => handleEdit(p)}
//                 className="mt-3 block mx-auto bg-blue-600 text-black px-4 py-2 rounded-xl hover:bg-blue-700"
//               >
//                 Edit
//               </button>
//             </div>
//           ))}
//         </div>
//       )}

//       {/* Centered Modal */}
//       <Modal
//         isOpen={modalOpen}
//         onRequestClose={() => setModalOpen(false)}
//         style={customStyles}
//         contentLabel="Edit Profile"
//       >
//         <h2 className="text-xl font-bold mb-4 text-center">Edit Profile</h2>

//         <input
//           className="w-full border px-3 py-2 mb-3 rounded-lg"
//           value={editedData.name || ""}
//           onChange={(e) =>
//             setEditedData({ ...editedData, name: e.target.value })
//           }
//         />
//         <input
//           className="w-full border px-3 py-2 mb-3 rounded-lg"
//           value={editedData.number || ""}
//           onChange={(e) =>
//             setEditedData({ ...editedData, number: e.target.value })
//           }
//         />
//         {/* <input
//           className="w-full border px-3 py-2 mb-3 rounded-lg"
//           value={editedData.image || ""}
//           onChange={(e) =>
//             setEditedData({ ...editedData, image: e.target.value })
//           }
//         /> */}

//          {/* ✅ Location */}
//   <input
//     className="w-full border px-3 py-2 mb-3 rounded-lg"
//     value={editedData.location || ""}
//     onChange={(e) =>
//       setEditedData({ ...editedData, location: e.target.value })
//     }
//     placeholder="Enter Location"
//   />


//         <div className="mb-4 text-center">
//   {/* ✅ Show current image */}
//   {editedData.image && (
//     <img
//       src={
//         previewImage
//           ? previewImage   // show preview if new image chosen
//           : editedData.image
//       }
//       alt="Profile"
//       className="w-32 h-32 object-cover rounded-full mx-auto mb-2 shadow-md"
//     />
//   )}

//   {/* ✅ File input to choose new image */}
//   <input
//     type="file"
//     accept="image/*"
//     className="w-full border px-3 py-2 rounded-lg"
//     onChange={(e) => {
//       const file = e.target.files[0];
//       if (file) {
//         setEditedData({ ...editedData, image: file }); // store new file separately
//         setPreviewImage(URL.createObjectURL(file)); // preview before upload
//       }
//     }}
//   />
// </div>


//         {!otpSent ? (
//           <button
//             onClick={handleSendOtp}
//             className="bg-blue-600 text-black px-4 py-2 rounded-lg w-full hover:bg-blue-700"
//           >
//             Send OTP
//           </button>
//         ) : (
//           <>
//             <input
//               className="w-full border px-3 py-2 mb-3 rounded-lg"
//               placeholder="Enter OTP"
//               value={otp}
//               onChange={(e) => setOtp(e.target.value)}
//             />

//             <button
//             onClick={handleSendOtp}
//             className="bg-blue-600 text-black px-4 py-2 rounded-lg w-full hover:bg-blue-700"
//           >
//             ReSend OTP
//           </button>
//             <button
//               onClick={handleVerifyOtp}
//               className="bg-green-600 text-black px-4 py-2 rounded-lg w-full hover:bg-green-700"
//             >
//               Verify OTP & Submit
//             </button>

//           </>
//         )}
//       </Modal>
//     </div>
//   );
// }

// export default ProfileForm;



























// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import Modal from "react-modal";
// import './style.css';
// Modal.setAppElement("#root"); // important for accessibility

// function ProfileForm() {
//   const [districts, setDistricts] = useState([]);
//   const [designations, setDesignations] = useState([]);
//   const [selectedDistrict, setSelectedDistrict] = useState("");
//   const [selectedDesignation, setSelectedDesignation] = useState("");
//   const [profiles, setProfiles] = useState([]);
//   const [modalOpen, setModalOpen] = useState(false);
//   const [editedData, setEditedData] = useState({});
//   const [otpSent, setOtpSent] = useState(false);
//   const [otp, setOtp] = useState("");
//   const [previewImage, setPreviewImage] = useState(null);

//   // Modal custom styles for centering
//   const customStyles = {
//     content: {
//       top: "50%",
//       left: "50%",
//       right: "auto",
//       bottom: "auto",
//       transform: "translate(-50%, -50%)",
//       borderRadius: "16px",
//       padding: "20px",
//       width: "400px",
//       maxWidth: "90%",
//       boxShadow: "0 8px 24px rgba(0,0,0,0.2)",
//     },
//     overlay: {
//       backgroundColor: "rgba(0,0,0,0.5)",
//       zIndex: 50,
//     },
//   };

//   // ✅ Load districts on first render
//   useEffect(() => {
//     axios.get("https://lcoiapi.emedha.in/api/profile/districts")
//       .then((res) => setDistricts(res.data));
//   }, []);

//   const handleDistrictChange = (e) => {
//     const district = e.target.value;
//     setSelectedDistrict(district);

//     axios.get(`https://lcoiapi.emedha.in/api/profile/designations/${district}`)
//       .then((res) => setDesignations(res.data));
//   };

//   const handleDesignationChange = (e) => {
//     const des = e.target.value;
//     setSelectedDesignation(des);
//     fetchProfiles(selectedDistrict, des);
//   };

//   // ✅ Fetch profiles (used in multiple places)
//   const fetchProfiles = (district = selectedDistrict, des = selectedDesignation) => {
//     if (!district || !des) return;
//     axios
//       .get(`https://lcoiapi.emedha.in/api/profile/${district}/${des}`)
//       .then((res) => setProfiles(res.data));
//   };

//   const handleEdit = (profile) => {
//     setEditedData(profile);
//     setPreviewImage(null); // reset preview
//     setOtp("");
//     setOtpSent(false);
//     setModalOpen(true);
//   };

//   const handleSendOtp = async () => {
//     const res = await axios.post("https://lcoiapi.emedha.in/api/otp/send-otp", {
//       email: editedData.email,
//     });
//     if (res.data.success) {
//       alert("OTP sent to email!");
//       setOtpSent(true);
//     }
//   };

//   // ✅ Reset modal state & reload DB data
//   const resetModal = () => {
//     setEditedData({});
//     setOtp("");
//     setOtpSent(false);
//     setPreviewImage(null);
//     setModalOpen(false);
//     fetchProfiles(); // refresh data
//   };

//   const handleVerifyOtp = async () => {
//     try {
//       const formData = new FormData();
//       formData.append("otp", otp);

//       // If user selected a new image file
//       if (editedData.image instanceof File) {
//         formData.append("image", editedData.image);
//       } else {
//         formData.append("image", editedData.image || "");
//       }

//       // Append all other fields
//       formData.append("id", editedData.id || "");
//       formData.append("name", editedData.name || "");
//       formData.append("desegnation", editedData.desegnation || "");
//       formData.append("email", editedData.email || "");
//       formData.append("number", editedData.number || "");
//       formData.append("year", editedData.year || "");
//       formData.append("district", editedData.district || "");
//       formData.append("location", editedData.location || "");
//       formData.append("leadership_team", editedData.leadership_team || "");

//       const res = await axios.post("https://lcoiapi.emedha.in/api/otp/verify-otp",
//         formData,
//         {
//           headers: { "Content-Type": "multipart/form-data" },
//         }
//       );

//       if (res.data.success) {
//         alert("Edit request submitted for admin approval!");
//         resetModal(); // ✅ close + reset + refresh DB
//       } else {
//         alert(res.data.message || "Invalid OTP!");
//       }
//     } catch (err) {
//       console.error("Error uploading:", err);
//       alert("Something went wrong!");
//     }
//   };


//   //   const [selectedDistrict, setSelectedDistrict] = useState("");
//   //   const [selectedDesignation, setSelectedDesignation] = useState("");

//   const [districtSearch, setDistrictSearch] = useState("");
//   const [designationSearch, setDesignationSearch] = useState("");

//   const filteredDistricts = districts.filter((d) =>
//     d.district.toLowerCase().includes(districtSearch.toLowerCase())
//   );

//   const filteredDesignations = designations.filter((d) =>
//     d.desegnation.toLowerCase().includes(designationSearch.toLowerCase())
//   );

//   // add this state
//   const [profileSearch, setProfileSearch] = useState("");

//   // filtered profiles (only apply search when designation is PDG)
//   const displayedProfiles =
//     selectedDesignation?.toLowerCase().trim() === "past district governor"
//       ? profiles.filter((p) =>
//         p.name?.toLowerCase().includes(profileSearch.toLowerCase()) ||
//         p.number?.toString().includes(profileSearch.toLowerCase()) ||
//         p.email?.toString().includes(profileSearch.toLowerCase()) // ✅ added number search

//       )
//       : profiles;


//   console.log('this is selectedDesignation', selectedDesignation)
//   return (
//     <>
//       <div className="top-bar">
//         {/* View the <a href="#">Official Call</a> and <a href="#">Notice of Amendments</a> to be voted on by the Delegates at the 2025 International Convention in Orlando. */}
//       </div>
//       <div className="p-6 max-w-4xl mx-auto">
//         {/* Filters */}

//         <div className="p-4 mb-4 flex gap-4" >
//           <div>
//             <h2>Select Districts</h2>

//             <select
//               className="border rounded-lg px-3 py-2 shadow "
//               onChange={handleDistrictChange}
//               value={selectedDistrict}
//             >
//               <option value="">Select District</option>
//               {districts.map((d) => (
//                 <option key={d.district} value={d.district}>
//                   {d.district}
//                 </option>
//               ))}
//             </select>
//           </div>

//           <div>
//             <h2>Select Designation</h2>

//             {selectedDistrict && (
//               <select
//                 className="border rounded-lg px-3 py-2 shadow"
//                 onChange={handleDesignationChange}
//                 value={selectedDesignation}
//               >
//                 <option value="">Select Designation</option>
//                 {designations.map((d) => (
//                   <option key={d.desegnation} value={d.desegnation}>
//                     {d.desegnation}
//                   </option>
//                 ))}
//               </select>
//             )}
//           </div>
//         </div>
//         {selectedDesignation?.toLowerCase().trim() === "past district governor" && (
//           <div style={{ textAlign: "center", marginBottom: "16px" }}>
//             <p style={{ fontSize: "18px", fontWeight: "600", marginBottom: "8px" }}>
//               🔍 Search by Name
//             </p>
//             <input
//               type="text"
//               placeholder="Search profiles..."
//               value={profileSearch}
//               onChange={(e) => setProfileSearch(e.target.value)}
//               className="border rounded-lg px-3 py-2 shadow w-full max-w-md"
//               style={{ width: "30%" }}
//             />
//           </div>
//         )}


//         {displayedProfiles.length > 0 && (
//           <div
//             style={{
//               display: "flex",
//               flexWrap: "wrap",
//               justifyContent: "center",
//               gap: 24,
//               padding: 24,
//               boxSizing: "border-box",
//             }}
//           >
//             {displayedProfiles.map((p) => {
//               // inline styles
//               const outerStyle = {
//                 width: "100%",
//                 maxWidth: 600,
//                 margin: "12px",
//                 boxSizing: "border-box",
//               };

//               const cardStyle = {
//                 position: "relative",
//                 display: "flex",
//                 alignItems: "center",
//                 gap: 20,
//                 background: "#ffffff",
//                 borderRadius: 14,
//                 padding: 20,
//                 boxShadow: "0 10px 22px rgba(13,38,59,0.08)",
//                 transition: "transform 280ms ease, box-shadow 280ms ease",
//                 overflow: "visible", // allow the half-circle to overflow
//                 cursor: "default",
//               };

//               const imageStyle = {
//                 width: 110,
//                 height: 110,
//                 borderRadius: "50%",
//                 objectFit: "cover",
//                 flexShrink: 0,
//                 border: "4px solid #ffffff",
//                 boxShadow: "0 6px 18px rgba(15, 23, 42, 0.08)",
//               };

//               const infoStyle = {
//                 flex: 1,
//                 display: "flex",
//                 flexDirection: "column",
//                 justifyContent: "center",
//                 zIndex: 2,
//               };

//               const nameStyle = {
//                 fontSize: 20,
//                 fontWeight: 700,
//                 color: "#0f172a",
//                 margin: 0,
//               };

//               const desigStyle = {
//                 color: "#0ea5a5",
//                 marginTop: 6,
//                 marginBottom: 8,
//                 fontWeight: 600,
//               };

//               const textStyle = {
//                 margin: "2px 0",
//                 color: "#475569",
//                 fontSize: 14,
//               };

//               const editBtnStyle = {
//                 marginTop: 12,
//                 alignSelf: "flex-start",
//                 padding: "8px 14px",
//                 borderRadius: 10,
//                 border: "none",
//                 background: "linear-gradient(90deg,#4f46e5,#06b6d4)",
//                 color: "#fff",
//                 fontWeight: 600,
//                 cursor: "pointer",
//                 boxShadow: "0 6px 16px rgba(79,70,229,0.18)",
//               };

//               // half-circle that will appear on hover; center at card top-right
//               const circleStyle = {
//                 position: "absolute",
//                 top: 0,
//                 right: 0,
//                 width: 160,
//                 height: 160,
//                 borderRadius: "50%",
//                 background:
//                   "conic-gradient(#ff4d4d, #ffbf4d, #88e36a, #4dd6ff, #9b8cff, #ff4d4d)",
//                 transform: "translate(50%, -50%)", // move circle so its CENTER is exactly at the card top-right corner
//                 clipPath: "inset(50% 50% 0 0)", // show only the top half of the circle (above the center)
//                 opacity: 0,
//                 transition: "opacity 260ms ease, transform 260ms ease",
//                 zIndex: 1,
//                 pointerEvents: "none",
//               };

//               return (
//                 <div key={p.id || p.email} style={outerStyle}>
//                   <div
//                     // wrapper that handles hover
//                     onMouseEnter={(e) => {
//                       const root = e.currentTarget;
//                       const card = root.querySelector(".card");
//                       const circle = root.querySelector(".card-circle");
//                       if (card) {
//                         card.style.transform = "translateY(-8px) rotateX(3deg) rotateY(2deg) scale(1.01)";
//                         card.style.boxShadow = "0 18px 40px rgba(13,38,59,0.18)";
//                       }
//                       if (circle) circle.style.opacity = "1";
//                     }}
//                     onMouseLeave={(e) => {
//                       const root = e.currentTarget;
//                       const card = root.querySelector(".card");
//                       const circle = root.querySelector(".card-circle");
//                       if (card) {
//                         card.style.transform = "none";
//                         card.style.boxShadow = "0 10px 22px rgba(13,38,59,0.08)";
//                       }
//                       if (circle) circle.style.opacity = "0";
//                     }}
//                     style={{ display: "block" }}
//                   >
//                     <div className="card" style={cardStyle}>
//                       {/* half-circle (centered at top-right of the card) */}
//                       <div className="card-circle" style={circleStyle} />

//                       {/* left: profile image */}
//                       <img src={p.image} alt={p.name} style={imageStyle} />

//                       {/* right: info */}
//                       <div style={infoStyle}>
//                         <h3 style={nameStyle}>{p.name}</h3>
//                         <div style={desigStyle}>{p.desegnation}</div>
//                         <div style={textStyle}>📧 {p.email}</div>
//                         <div style={textStyle}>📞 {p.number}</div>

//                         <button
//                           onClick={() => handleEdit(p)}
//                           style={editBtnStyle}
//                         >
//                           Edit
//                         </button>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               );
//             })}
//           </div>
//         )}





//         {/* Centered Modal */}
//         <Modal
//           isOpen={modalOpen}
//           onRequestClose={resetModal} // ✅ close + reset when clicking X or overlay
//           style={customStyles}
//           contentLabel="Edit Profile"
//         >
//           <h2 className="text-xl font-bold mb-4 text-center">Edit Profile</h2>

//           <input
//             className="w-full border px-3 py-2 mb-3 rounded-lg"
//             value={editedData.name || ""}
//             onChange={(e) =>
//               setEditedData({ ...editedData, name: e.target.value })
//             }
//           />
//           <input
//             className="w-full border px-3 py-2 mb-3 rounded-lg"
//             value={editedData.number || ""}
//             onChange={(e) =>
//               setEditedData({ ...editedData, number: e.target.value })
//             }
//           />

//           {/* ✅ Location input */}
//           <input
//             className="w-full border px-3 py-2 mb-3 rounded-lg"
//             value={editedData.location || ""}
//             onChange={(e) =>
//               setEditedData({ ...editedData, location: e.target.value })
//             }
//             placeholder="Enter Location"
//           />

//           <div className="mb-4 text-center">
//             {/* ✅ Show current image */}
//             {editedData.image && (
//               <img
//                 src={previewImage ? previewImage : editedData.image}
//                 alt="Profile"
//                 className=" object-cover rounded-full mx-auto mb-2 shadow-md"
//                 style={{
//                   objectFit: 'contain',
//                   width: "220px",
//                   height: "200px",
//                   maxWidth: "100%",  // ensures it won't overflow
//                 }}
//               />
//             )}

//             {/* ✅ File input to choose new image */}
//             <input
//               type="file"
//               accept="image/*"
//               className="w-full border px-3 py-2 rounded-lg"
//               onChange={(e) => {
//                 const file = e.target.files[0];
//                 if (file) {
//                   setEditedData({ ...editedData, image: file }); // store new file
//                   setPreviewImage(URL.createObjectURL(file)); // preview before upload
//                 }
//               }}
//             />
//           </div>

//           {!otpSent ? (
//             <button style={{ backgroundColor: 'lightblue', borderRadius: '5px' }}
//               onClick={handleSendOtp}
//               className="bg-blue-600 text-black px-4 py-2 rounded-lg w-full hover:bg-blue-700"
//             >
//               Send OTP To the Register Email
//             </button>
//           ) : (
//             <>
//               <input
//                 className="w-full border px-3 py-2 mb-3 rounded-lg"
//                 placeholder="Enter OTP"
//                 value={otp}
//                 onChange={(e) => setOtp(e.target.value)}
//               />

//               <button
//                 onClick={handleSendOtp}
//                 className="bg-blue-600 text-black px-4 py-2 rounded-lg w-full hover:bg-blue-700"
//               >
//                 ReSend OTP
//               </button>
//               <button
//                 onClick={handleVerifyOtp}
//                 className="bg-green-600 text-black px-4 py-2 rounded-lg w-full hover:bg-green-700"
//               >
//                 Verify OTP & Submit
//               </button>
//             </>
//           )}
//         </Modal>
//       </div>
//       <div className="top-bar">
//         {/* View the <a href="#">Official Call</a> and <a href="#">Notice of Amendments</a> to be voted on by the Delegates at the 2025 International Convention in Orlando. */}
//       </div>
//     </>
//   );
// }

// export default ProfileForm;





import React, { useEffect, useState } from "react";
import axios from "axios";
import Modal from "react-modal";
import Select from "react-select";
import { State, City } from "country-state-city";
import './style.css';

Modal.setAppElement("#root");

function ProfileForm() {
  const [districts, setDistricts] = useState([]);
  const [designations, setDesignations] = useState([]);
  const [selectedDistrict, setSelectedDistrict] = useState("");
  const [selectedDesignation, setSelectedDesignation] = useState("");
  const [profiles, setProfiles] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [editedData, setEditedData] = useState({});
  const [otpSent, setOtpSent] = useState(false);
  const [otp, setOtp] = useState("");
  const [previewImage, setPreviewImage] = useState(null);

  // States & Cities for India (IN)
  const indianStates = State.getStatesOfCountry("IN").map((s) => ({
    label: s.name,
    value: s.name,
    isoCode: s.isoCode,
  }));

  const [selectedStateObj, setSelectedStateObj] = useState(null);
  const [cityOptions, setCityOptions] = useState([]);

  const customStyles = {
    content: { top: "50%", left: "50%", right: "auto", bottom: "auto", transform: "translate(-50%, -50%)", borderRadius: "20px", padding: "28px", width: "500px", maxWidth: "92%", maxHeight: "90vh", overflowY: "auto", boxShadow: "0 25px 50px -12px rgba(15, 23, 42, 0.25)", border: "1px solid #e2e8f0", background: "#ffffff", fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif", },
    overlay: { backgroundColor: "rgba(15, 23, 42, 0.65)", backdropFilter: "blur(6px)", zIndex: 50, },
  };

  const customSelectStyles = {
    control: (base, state) => ({ ...base, borderRadius: "10px", borderColor: state.isFocused ? "#0d9488" : "#cbd5e1", borderWidth: "1.5px", padding: "2px 4px", boxShadow: state.isFocused ? "0 0 0 3px rgba(13, 148, 136, 0.15)" : "none", "&:hover": { borderColor: "#0d9488" }, fontSize: "14px", }),
    menu: (base) => ({ ...base, borderRadius: "10px", zIndex: 9999, boxShadow: "0 10px 25px rgba(0,0,0,0.1)", }),
    option: (base, state) => ({ ...base, backgroundColor: state.isSelected ? "#0d9488" : state.isFocused ? "#f1f5f9" : "#ffffff", color: state.isSelected ? "#ffffff" : "#0f172a", fontSize: "14px", cursor: "pointer", }),
  };

  // ✅ Load districts on first render
  useEffect(() => {
    axios.get("https://lcoiapi.emedha.in/api/profile/districts")
      .then((res) => setDistricts(res.data));
  }, []);

  const handleDistrictChange = (e) => {
    const district = e.target.value;
    setSelectedDistrict(district);

    axios.get(`https://lcoiapi.emedha.in/api/profile/designations/${district}`)
      .then((res) => setDesignations(res.data));
  };

  const handleDesignationChange = (e) => {
    const des = e.target.value;
    setSelectedDesignation(des);
    fetchProfiles(selectedDistrict, des);
  };

  const fetchProfiles = (district = selectedDistrict, des = selectedDesignation) => {
    if (!district || !des) return;
    axios
      .get(`https://lcoiapi.emedha.in/api/profile/${district}/${des}`)
      .then((res) => setProfiles(res.data));
  };

  const handleEdit = (profile) => {
    setPreviewImage(null);
    setOtp("");
    setOtpSent(false);

    if (profile.state) {
      const matchState = indianStates.find(
        (s) => s.value.toLowerCase() === profile.state.toLowerCase()
      );

      if (matchState) {
        setSelectedStateObj(matchState);

        const cities = City.getCitiesOfState(
          "IN",
          matchState.isoCode
        ).map((c) => ({
          label: c.name,
          value: c.name,
        }));

        setCityOptions(cities);

        setEditedData({
          ...profile,
          state: matchState.value,
          city: profile.city || "",
        });
      } else {
        setSelectedStateObj(null);
        setCityOptions([]);

        setEditedData({
          ...profile,
          state: profile.state || "",
          city: profile.city || "",
        });
      }
    } else {
      setSelectedStateObj(null);
      setCityOptions([]);

      setEditedData({
        ...profile,
        state: "",
        city: "",
      });
    }

    setModalOpen(true);
  };

  const handleStatePluginChange = (selected) => {
    setSelectedStateObj(selected);
    setEditedData((prev) => ({ ...prev, state: selected ? selected.value : "", city: "" }));
    if (selected && selected.isoCode) {
      const cities = City.getCitiesOfState("IN", selected.isoCode).map((c) => ({
        label: c.name,
        value: c.name,
      }));
      setCityOptions(cities);
    } else {
      setCityOptions([]);
    }
  };

  const handleCityPluginChange = (selected) => {
    setEditedData((prev) => ({ ...prev, city: selected ? selected.value : "" }));
  };

  const handleSendOtp = async () => {
    if (!editedData.email) {
      alert("Email is missing!");
      return;
    }
    const res = await axios.post("https://lcoiapi.emedha.in/api/otp/send-otp", {
      email: editedData.email.trim(),
    });
    if (res.data.success) {
      alert("OTP sent to email!");
      setOtpSent(true);
    }
  };

  const resetModal = () => {
    setEditedData({});
    setOtp("");
    setOtpSent(false);
    setPreviewImage(null);
    setSelectedStateObj(null);
    setCityOptions([]);
    setModalOpen(false);
    fetchProfiles();
  };

  const isFormValid =
    Boolean(editedData.name?.trim()) &&
    Boolean(editedData.number?.trim()) &&
    Boolean(editedData.state?.trim()) &&
    Boolean(editedData.city?.trim()) &&
    Boolean(editedData.location?.trim()) &&
    Boolean(editedData.email?.trim());

  const handleVerifyOtp = async () => {
    try {
      const formData = new FormData();
      formData.append("otp", otp.trim());

      if (editedData.image instanceof File) {
        formData.append("image", editedData.image);
      } else {
        formData.append("image", editedData.image || "");
      }
      formData.append("id", editedData.id || "");
      formData.append("name", editedData.name || "");
      formData.append("desegnation", editedData.desegnation || "");
      formData.append("email", editedData.email ? editedData.email.trim() : "");
      formData.append("number", editedData.number || "");
      formData.append("year", editedData.year || "");
      formData.append("district", editedData.district || "");
      formData.append("state", editedData.state || "");
      formData.append("city", editedData.city || "");
      formData.append("location", editedData.location || "");
      formData.append("leadership_team", editedData.leadership_team || "");
      const res = await axios.post("https://lcoiapi.emedha.in/api/otp/verify-otp",
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );
      if (res.data.success) {
        alert("Edit request submitted for admin approval!");
        resetModal();
      } else {
        alert(res.data.message || "Invalid OTP!");
      }
    } catch (err) {
      console.error("Error uploading:", err);
      alert("Something went wrong!");
    }
  };





  const [districtSearch, setDistrictSearch] = useState("");
  const [designationSearch, setDesignationSearch] = useState("");
  const [profileSearch, setProfileSearch] = useState("");

  const displayedProfiles =
    selectedDesignation?.toLowerCase().trim() === "past district governor"
      ? profiles.filter((p) =>
        p.name?.toLowerCase().includes(profileSearch.toLowerCase()) ||
        p.number?.toString().includes(profileSearch.toLowerCase()) ||
        p.email?.toString().includes(profileSearch.toLowerCase())
      )
      : profiles;

  // Core Aesthetic Styles
  const pageContainerStyle = { minHeight: "100vh", backgroundColor: "#f8fafc", fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, sans-serif", color: "#0f172a", margin: 0, padding: 0, display: "flex", flexDirection: "column" };
  const topBarStyle = { backgroundColor: "#0f172a", color: "#94a3b8", fontSize: "13px", textAlign: "center", padding: "10px 16px", letterSpacing: "0.02em" };
  const contentContainerStyle = { padding: "32px 20px", maxWidth: "1000px", margin: "0 auto", width: "100%", boxSizing: "border-box", flex: 1 };
  const filterBoxStyle = { backgroundColor: "#ffffff", borderRadius: "16px", padding: "24px", marginBottom: "28px", display: "flex", gap: "24px", flexWrap: "wrap", boxShadow: "0 4px 20px -2px rgba(15, 23, 42, 0.05)", border: "1px solid #e2e8f0" };
  const selectGroupStyle = { flex: 1, minWidth: "220px", display: "flex", flexDirection: "column", gap: "8px" };
  const labelStyle = { fontSize: "13px", fontWeight: "600", color: "#475569", textTransform: "uppercase", letterSpacing: "0.05em", margin: 0 };
  const selectStyle = { width: "100%", padding: "12px 16px", fontSize: "14px", fontWeight: "500", color: "#0f172a", backgroundColor: "#ffffff", border: "1.5px solid #cbd5e1", borderRadius: "10px", outline: "none", cursor: "pointer", boxShadow: "0 1px 2px rgba(0, 0, 0, 0.05)", transition: "border-color 0.2s ease, box-shadow 0.2s ease" };
  const inputBaseStyle = { width: "100%", padding: "12px 16px", fontSize: "14px", color: "#0f172a", backgroundColor: "#ffffff", border: "1.5px solid #cbd5e1", borderRadius: "10px", outline: "none", boxSizing: "border-box", transition: "border-color 0.2s ease, box-shadow 0.2s ease" };

  return (
    <div style={pageContainerStyle}>
      <div style={topBarStyle}>
        {/* Top Header */}
      </div>

      <div style={contentContainerStyle}>
        {/* Filters Box */}
        <div style={filterBoxStyle}>
          <div style={selectGroupStyle}>
            <h2 style={labelStyle}>Select District</h2>
            <select style={selectStyle} onChange={handleDistrictChange} value={selectedDistrict}>
              <option value="">Select District</option>
              {districts.map((d) => (
                <option key={d.district} value={d.district}>
                  {d.district}
                </option>
              ))}
            </select>
          </div>

          <div style={selectGroupStyle}>
            <h2 style={labelStyle}>Select Designation</h2>
            {selectedDistrict ? (
              <select style={selectStyle} onChange={handleDesignationChange} value={selectedDesignation}>
                <option value="">Select Designation</option>
                {designations.map((d) => (
                  <option key={d.desegnation} value={d.desegnation}>
                    {d.desegnation}
                  </option>
                ))}
              </select>
            ) : (
              <select style={{ ...selectStyle, backgroundColor: "#f1f5f9", cursor: "not-allowed", opacity: 0.7 }} disabled>
                <option value="">Select District First</option>
              </select>
            )}
          </div>
        </div>

        {/* Search Input for Past District Governor */}
        {selectedDesignation?.toLowerCase().trim() === "past district governor" && (
          <div style={{ textAlign: "center", marginBottom: "28px" }}>
            <p style={{ fontSize: "16px", fontWeight: "600", color: "#334155", marginBottom: "10px", display: "flex", alignItems: "center", justifyContent: "center", gap: "6px" }}>🔍 Search Profiles</p>
            <input type="text" placeholder="Search by name, email or number..." value={profileSearch} onChange={(e) => setProfileSearch(e.target.value)} style={{ ...inputBaseStyle, maxWidth: "420px", boxShadow: "0 4px 12px rgba(15, 23, 42, 0.05)", }} />
          </div>
        )}

        {/* Profile Cards */}
        {displayedProfiles.length > 0 && (
          <div style={{ display: "flex", flexWrap: "wrap", justifyContent: "center", gap: 24, padding: 0, boxSizing: "border-box" }}>
            {displayedProfiles.map((p) => {
              const outerStyle = { width: "100%", maxWidth: 600, margin: "0", boxSizing: "border-box" };
              const cardStyle = { position: "relative", display: "flex", alignItems: "center", gap: 20, background: "#ffffff", borderRadius: 16, padding: 24, boxShadow: "0 10px 25px -5px rgba(15, 23, 42, 0.08)", border: "1px solid #f1f5f9", transition: "transform 280ms ease, box-shadow 280ms ease", overflow: "visible", cursor: "default" };
              const imageStyle = { width: 100, height: 100, borderRadius: "50%", objectFit: "cover", flexShrink: 0, border: "3px solid #ffffff", boxShadow: "0 8px 16px rgba(15, 23, 42, 0.12)" };
              const infoStyle = { flex: 1, display: "flex", flexDirection: "column", justifyContent: "center", zIndex: 2 };
              const nameStyle = { fontSize: 18, fontWeight: 700, color: "#0f172a", margin: 0, letterSpacing: "-0.01em" };
              const desigStyle = { color: "#0d9488", marginTop: 4, marginBottom: 8, fontWeight: 600, fontSize: 14 };
              const textStyle = { margin: "3px 0", color: "#64748b", fontSize: 13, display: "flex", alignItems: "center", gap: "6px" };
              const editBtnStyle = { marginTop: 14, alignSelf: "flex-start", padding: "8px 16px", borderRadius: 8, border: "none", background: "linear-gradient(135deg, #0d9488 0%, #0284c7 100%)", color: "#ffffff", fontSize: 13, fontWeight: 600, cursor: "pointer", boxShadow: "0 4px 12px rgba(13, 148, 136, 0.25)", transition: "all 0.2s ease" };
              const circleStyle = { position: "absolute", top: 0, right: 0, width: 160, height: 160, borderRadius: "50%", background: "conic-gradient(#ff4d4d, #ffbf4d, #88e36a, #4dd6ff, #9b8cff, #ff4d4d)", transform: "translate(50%, -50%)", clipPath: "inset(50% 50% 0 0)", opacity: 0, transition: "opacity 260ms ease, transform 260ms ease", zIndex: 1, pointerEvents: "none" };

              return (
                <div key={p.id || p.email} style={outerStyle}>
                  <div
                    onMouseEnter={(e) => {
                      const root = e.currentTarget;
                      const card = root.querySelector(".card");
                      const circle = root.querySelector(".card-circle");
                      if (card) {
                        card.style.transform = "translateY(-6px) rotateX(2deg) rotateY(1deg) scale(1.01)";
                        card.style.boxShadow = "0 20px 30px -10px rgba(15, 23, 42, 0.15)";
                      }
                      if (circle) circle.style.opacity = "1";
                    }}
                    onMouseLeave={(e) => {
                      const root = e.currentTarget;
                      const card = root.querySelector(".card");
                      const circle = root.querySelector(".card-circle");
                      if (card) {
                        card.style.transform = "none";
                        card.style.boxShadow = "0 10px 25px -5px rgba(15, 23, 42, 0.08)";
                      }
                      if (circle) circle.style.opacity = "0";
                    }}
                    style={{ display: "block" }}
                  >
                    <div className="card" style={cardStyle}>
                      <div className="card-circle" style={circleStyle} />
                      <img src={p.image} alt={p.name} style={imageStyle} />
                      <div style={infoStyle}>
                        <h3 style={nameStyle}>{p.name}</h3>
                        <div style={desigStyle}>{p.desegnation}</div>
                        <div style={textStyle}>📧 {p.email}</div>
                        <div style={textStyle}>📞 {p.number}</div>
                        <button onClick={() => handleEdit(p)} style={editBtnStyle}>Edit Profile</button>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        )}

        {/* Centered Modal */}
        <Modal isOpen={modalOpen} onRequestClose={resetModal} style={customStyles} contentLabel="Edit Profile">
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "20px", paddingBottom: "12px", borderBottom: "1px solid #f1f5f9" }}>
            <h2 style={{ fontSize: "20px", fontWeight: "700", color: "#0f172a", margin: 0 }}>Edit Profile</h2>
            <button onClick={resetModal} style={{ background: "none", border: "none", fontSize: "18px", color: "#94a3b8", cursor: "pointer", padding: "4px" }}>✕</button>
          </div>
          <div style={{ display: "flex", flexDirection: "column", gap: "14px" }}>
            <div>
              <label style={{ fontSize: "12px", fontWeight: "600", color: "#64748b", marginBottom: "4px", display: "block" }}>Full Name</label>
              <input style={inputBaseStyle} value={editedData.name || ""} onChange={(e) => setEditedData({ ...editedData, name: e.target.value })} placeholder="Name" />
            </div>
            <div>
              <label style={{ fontSize: "12px", fontWeight: "600", color: "#64748b", marginBottom: "4px", display: "block" }}>Phone Number</label>
              <input style={inputBaseStyle} value={editedData.number || ""} onChange={(e) => setEditedData({ ...editedData, number: e.target.value })} placeholder="Phone Number" />
            </div>

            {/* Email Field with Verification and Support Note */}
            <div>
              <label style={{ fontSize: "12px", fontWeight: "600", color: "#64748b", marginBottom: "4px", display: "block" }}>Registered Email (OTP will be sent here)</label>
              <input
                style={{ ...inputBaseStyle, backgroundColor: "#f8fafc", color: "#334155" }}
                value={editedData.email || ""}
                disabled
                placeholder="Email Address"
              />
              <p style={{ fontSize: "11px", color: "#64748b", marginTop: "4px", lineHeight: "1.4" }}>
                If this email is incorrect, please contact support at <strong style={{ color: "#0f172a" }}>98491 64361</strong> to update it.
              </p>
            </div>

            <div>
              <label style={{ fontSize: "12px", fontWeight: "600", color: "#64748b", marginBottom: "4px", display: "block" }}>State</label>
              <Select options={indianStates} styles={customSelectStyles} placeholder="Select State..." value={selectedStateObj} onChange={handleStatePluginChange} isClearable />
            </div>
            <div>
              <label style={{ fontSize: "12px", fontWeight: "600", color: "#64748b", marginBottom: "4px", display: "block" }}>City</label>
              <Select options={cityOptions} styles={customSelectStyles} placeholder={selectedStateObj ? "Select City..." : "Select State First"} value={editedData.city ? { label: editedData.city, value: editedData.city } : null} onChange={handleCityPluginChange} isDisabled={!selectedStateObj} isClearable />
            </div>
            <div>
              <label style={{ fontSize: "12px", fontWeight: "600", color: "#64748b", marginBottom: "4px", display: "block" }}>Location</label>
              <textarea rows="3" style={{ ...inputBaseStyle, resize: "vertical", fontFamily: "inherit" }} value={editedData.location || ""} onChange={(e) => setEditedData({ ...editedData, location: e.target.value })} placeholder="Enter Location" />
            </div>
            <div style={{ textAlign: "center", margin: "6px 0" }}>
              <label style={{ fontSize: "12px", fontWeight: "600", color: "#64748b", marginBottom: "4px", display: "block" }}>Please upload a valid profile image (PNG, JPG, or JPEG only)</label>
              {editedData.image && (
                <div style={{ width: "100px", height: "100px", borderRadius: "50%", overflow: "hidden", margin: "0 auto 12px auto", border: "3px solid #e2e8f0", boxShadow: "0 4px 10px rgba(0, 0, 0, 0.05)" }}>
                  <img src={previewImage ? previewImage : editedData.image} alt="Profile" style={{ objectFit: 'cover', width: "100%", height: "100%" }} />
                </div>
              )}
              <input type="file" accept="image/*" style={{ width: "100%", padding: "8px", fontSize: "12px", border: "1px dashed #cbd5e1", borderRadius: "8px", backgroundColor: "#f8fafc", cursor: "pointer" }}
                onChange={(e) => {
                  const file = e.target.files[0];
                  if (file) {
                    setEditedData({ ...editedData, image: file });
                    setPreviewImage(URL.createObjectURL(file));
                  }
                }}
              />
            </div>

            {!otpSent ? (
              <button
                onClick={handleSendOtp}
                disabled={!isFormValid}
                style={{
                  width: "100%",
                  padding: "12px",
                  borderRadius: "10px",
                  border: "none",
                  backgroundColor: isFormValid ? "#0284c7" : "#cbd5e1",
                  color: "#ffffff",
                  fontSize: "14px",
                  fontWeight: "600",
                  cursor: isFormValid ? "pointer" : "not-allowed",
                  marginTop: "8px",
                  boxShadow: isFormValid ? "0 4px 12px rgba(2, 132, 199, 0.25)" : "none",
                  opacity: isFormValid ? 1 : 0.7
                }}
              >
                Send OTP To Registered Email
              </button>
            ) : (
              <div style={{ display: "flex", flexDirection: "column", gap: "10px", marginTop: "4px" }}>
                <input style={{ ...inputBaseStyle, textAlign: "center", letterSpacing: "0.1em", fontWeight: "600" }} placeholder="Enter 6-Digit OTP" value={otp} onChange={(e) => setOtp(e.target.value)} />

                <div style={{ display: "flex", gap: "10px" }}>
                  <button onClick={handleSendOtp} style={{ flex: 1, padding: "10px", borderRadius: "8px", border: "none", backgroundColor: "#e2e8f0", color: "#334155", fontSize: "13px", fontWeight: "600", cursor: "pointer" }}>Resend OTP</button>
                  <button onClick={handleVerifyOtp} style={{ flex: 1, padding: "10px", borderRadius: "8px", border: "none", backgroundColor: "#059669", color: "#ffffff", fontSize: "13px", fontWeight: "600", cursor: "pointer", boxShadow: "0 4px 12px rgba(5, 150, 105, 0.25)" }}>Verify & Submit</button>
                </div>
              </div>
            )}
          </div>
        </Modal>

      </div>
    </div>
  );
}

export default ProfileForm;